export default function getCorrelationId() {
  const date = new Date();
  const timeInMilliseconds = date.getTime();
  const randomId = Math.floor(Math.random() * 1000000);

  return `OCC-${timeInMilliseconds}-${randomId}`;
}
